











import Vue from 'vue'
import Component from 'vue-class-component'
import { State, Getter, Action, Mutation } from 'vuex-class'
import { mapMutations } from 'vuex'

@Component
export default class DmoMenu extends Vue {
  @Getter('modes') modes
  @Mutation('SELECT_MODE') SELECT_MODE

  activeMode = null

  created() {
    this.activeMode = this.modes.find(item => item.active)
  }

  select(item) {
    if (item !== this.activeMode) {
      this.activeMode = item
      this.SELECT_MODE(item.key)
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/menu.vue